@if (isValidateField) {<div class="{{newClass}}">{{isValidateField}}</div>}